export default "__VITE_ASSET__ae34a216__"